import { HoursCounter } from "@/components/HoursCounter";

export default function ContadorHoras() {
  return (
    <div data-testid="contador-horas-page">
      <HoursCounter />
    </div>
  );
}
